<template>
    <div class="files" >
        <div class="row">
            <div class= "col">
                <div class="card mb-3 p-0 ">
                    <div class="card-body px-3 py-1 m-0">
                        <nav class="navbar navbar-expand-lg">
                          <div class="container-fluid">
                            <span class="navbar-brand mb-0 h2">Steps:</span>
                            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#filter-navbar" aria-controls="filter-navbar" aria-expanded="false" aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon"></span>
                            </button>
                            <div class="collapse navbar-collapse" id="filter-navbar">
                              <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                                <li class="nav-item me-4">
                                  <a class="nav-link d-flex flex-nowrap" :class="{'text-dark': step_num==1}" href="#" role="button" aria-expanded="false" @click.prevent="step_num=1">
                                    <div class="rounded-circle avatar flex-fill" :class="step_num==1?'primary':''">1</div> <span class="m-2">Information</span>
                                  </a>
                                </li>
                                <li class="nav-item me-4">
                                  <a class="nav-link d-flex flex-nowrap" :class="{'pe-none': (step_num == 1), 'text-dark': step_num==2}" href="#" role="button" aria-expanded="false" @click.prevent="step_num=2">
                                    <div class="rounded-circle avatar flex-fill" :class="step_num==2?'primary':''">2</div> <span class="m-2">Filters</span>
                                  </a>
                                </li>
                                <li class="nav-item me-4">
                                  <a class="nav-link d-flex flex-nowrap" :class="{'pe-none': (step_num <= 2), 'text-dark': step_num==3}" href="#" role="button" aria-expanded="false">
                                    <div class="rounded-circle avatar flex-fill" :class="step_num==3?'primary':''">3</div> <span class="m-2">Column Mapping</span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-show="step_num==1">
            <div class="col"> 
                <div class="card mb-3">
                    <div class="card-body">
                        <h3>Data Set Information</h3>
                        <p>A "data set" is a view of the data extracted from your integrated systems. To be properly used within the system, we need to establish the information about the data set and the most commonly used data points need to be mapped to standard columns. If there are additional columns you'd like to use for filters, be sure to add those columns too.</p>
                        <p class="mb-3">Would you like more information about the columns and how the information is used? <a href="https://help.avidai.com/hc/en-us/articles/42928674866963-Integrations-Data-Sets-and-More" target="_blank">Check Avid's Knowledge Base.</a></p>
                        <div class="mb-3">
                            <label class="form-label">Data Set Name</label>
                            <input type="text" class="form-control" :class="{'is-invalid': errors.name != ''}"
                                name="name" v-model="local_dataset.name" @input="form.error = false; errors.name=''" aria-label="Data Set Name">
                            <div class="text-danger invalid-feedback" v-if="errors.name != ''">
                                {{errors.name}}
                            </div>
                        </div>
                        <div class="mb-3" v-show="file_or_dataset == 'file' || errors.category != ''">
                            <label class="form-label">Data Category</label>
                            <select class="form-select" v-model="local_dataset.source_type_id"
                                @change="setDataSourceType()" :class="{'is-invalid': errors.category != ''}" aria-label="Data Category">
                                <option v-for="(cols, key) in source_types" :key="key" :value="key">{{key}}</option>
                            </select>
                            <div class="text-danger invalid-feedback" v-if="errors.category != ''">
                                {{errors.category}}
                            </div>
                            <!-- Category Description Alert -->
                            <div class="alert bg-secondary mt-2" v-if="local_dataset.source_type_id && categoryDescription">
                                <p class="mb-2"><img class="icon me-2" src="/img/icons/avid-icons/info.svg" style="width: 20px;" alt=""></img>
                                <strong>{{ local_dataset.source_type_id }}:</strong> {{ categoryDescription }} </p>
                                <p class="mb-0">For more information on these categories, see <a href="https://help.avidai.com/hc/en-us/articles/42928646830099--Add-a-Data-Set" target="_blank">Avid's Knowledge Base.</a></p>
                            </div>
                        </div>
                        <div v-show="local_dataset.source != 'Airbyte' && local_dataset.source != 'Table'">
                            <div class="mb-3">
                                <label class="form-label">Refresh Type</label>
                                <select class="form-select" v-model="local_dataset.settings.refresh_type" @change="columnsValid()" aria-label="Refresh Type">
                                    <option value="incremental">Append: New files are merged with prior uploads</option>
                                    <option value="full">Replace: New files replace prior uploads</option>
                                </select>
                                <em class="small" v-if="local_dataset.settings.refresh_type == 'incremental'">When appending files, the "Updated At" field will ensure the most recent record is used (if it is set on the Column Mapping screen).</em>
                            </div>
                            <div class="mb-3" v-show="local_dataset.settings.refresh_type == 'incremental'">
                                <label class="form-label" data-bs-toggle="tooltip" title="When appending files, you can select one or more columns to be used as a unique ID. Records with the same ID as a record in a prior upload will be used as a replacement rather than a new record. If no columns are selected, records will always be appended.">Column(s) to Identify Unique Records <img class="info-icon" src="/img/icons/avid-icons/info.svg" alt=""></img></label>
                                <div class="dropdown">
                                  <button class="btn form-select btn-field" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bs-auto-close="outside">
                                    <span v-if="(local_dataset.settings.id_columns != null && local_dataset.settings.id_columns.length > 0 )">{{ id_columns }}</span><span v-else><em>None Selected</em></span>
                                  </button>
                                  <div class="dropdown-menu dropdown-menu-primary"  style="max-height: 250px; overflow-y: auto;" aria-labelledby="dropdownMenuButton">
                                      <label class="dropdown-item" v-for="(item, key) in sortedSourceColumns" :key="key">
                                        <input class="form-check-input" type="checkbox" :value="key" v-model="local_dataset.settings.id_columns" :true-value="[]" aria-label="Id Columns">
                                        <span class="ms-2">{{ item }}</span>
                                      </label>
                                  </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="form-label" data-bs-toggle="tooltip" title="Identify what files should be included in this data set. You can use a wildcard character (%) if there are parts of the file name that will change with each upload or, for more advanced rules, use a regular expression by starting the pattern with r' and ending it with a '">File Name Pattern <img class="info-icon" src="/img/icons/avid-icons/info.svg" alt=""></img></label>
                                <input type="text" class="form-control" :class="{'is-invalid': errors.pattern != ''}"
                                    name="pattern" v-model="local_dataset.settings.pattern" @change="refreshFiles()" aria-label="Pattern">
                                <div class="text-danger invalid-feedback" v-if="errors.pattern != ''">
                                    {{errors.pattern}}
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-check">
                                  <input class="form-check-input" type="checkbox" id="ignore_unused" v-model="local_dataset.settings.ignore_unused" @change="columnsValid()" aria-label="Ignore Unused">
                                  <label class="form-check-label" for="ignore_unused">
                                    <strong>Ignore Unused Column Changes.</strong> If columns are added or removed in future uploads, the file will still process when the changes don't impact existing mappings.
                                  </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4" v-show="local_dataset.source != 'Airbyte' && local_dataset.source != 'Table'">
                <div class="card mb-3 px-0 py-2 overflow-hidden">
                    <div class="card-body px-0 pb-0">
                        <p class="px-3">Based upon the pattern specified, the following files will be included in this data set:</p>
                        <div class="table-responsive" style="max-height: 300px;" v-if="local_files.length > 0">
                            <table class="table w-100">
                                <thead class="table-dark">
                                    <tr>
                                        <th class='align-middle'>File Name</th>
                                        <th class="align-middle" colspan="2">Uploaded At</th>
                                    </tr>
                                </thead>
                                <transition-group tag="tbody" name="table-row" class="table-border-bottom-0">
                                    <tr v-for="(f, index) in local_files" :key="f.id" :class="{'error': f.status_msg == 'MISMATCH'}">
                                        <td class='ps-3 align-middle'>
                                            {{f.name}}
                                        </td>
                                        <td class="align-middle text-nowrap" :colspan="(f.status_msg == 'MISMATCH'? '1' : '2')">{{ datetime(f.created_at) }}</td>
                                        <td v-if="f.status_msg == 'MISMATCH'" class="text-end"><button type="button" class="btn btn-sm btn-none red"><i class="fa fa-trash" @click="removeFile(f)"></i></button></td>
                                    </tr>
                                </transition-group>
                            </table>
                        </div>
                        <div v-else>
                            <p class="px-3"><strong><em>No files were found that match the given pattern.</em></strong></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-show="step_num==1">
            <div class="col">
                <div class="alert alert-danger mb-3" v-if="form.error">
                    There is an issue with the information provided in the form above. Please check the fields and make the necessary corrections.
                </div>
                <!-- Save Button -->
                <div class="mb-3">
                    <button type="submit" class="btn btn-primary" @click.prevent="nextStep()" :disabled="form.busy">
                         <span v-if="file_or_dataset == 'data_set'">Save & </span>Next <div v-if="form.busy" class="spinner-border spinner-border-sm float-left ms-1" role="status"></div><i v-else class="fa fa-chevron-right ms-1"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="row" v-show="step_num==2">
            <div class="col mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-start mb-2">
                            <div>
                                <h2>Inclusion Filters <em><small>(Optional)</small></em></h2>
                                <p>You are able to limit the records in your data set. This is helpful if removing records like soft credits from a list of transactions or non-donors from a list of constituents.</p>
                            </div>
                        </div>
                        <query-builder :client="client" v-model="local_dataset.filter" :id="'dataset-inclusion-filters-'+dataset.id" :key="dataset.id"  
                            :static_db_columns="local_dataset.source_columns"
                            :include_trans="false" :source="file_or_dataset" :in_card="true" :add_blank="false"
                            :data_source_id="object_id" ref="filter"></query-builder>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-show="step_num==2">
            <div class="col">
                <div class="alert alert-danger mb-3" v-if="form.error">
                    There is an issue with the information provided in the fields above. Please check your entries and make the necessary corrections.
                </div>
                <!-- Save Button -->
                <div class="mb-3">
                    
                    <button 
                        v-if="file_or_dataset === 'file'" 
                        class="btn btn-secondary me-2" 
                        :class="{'is-generating': filterSuggestionLoading, 'generating-background': filterSuggestionLoading}"
                        @click="requestFilterSuggestion"
                        :disabled="filterSuggestionLoading"
                        data-bs-toggle="tooltip" 
                        title="Get AI filter suggestions"
                    >
                        <span v-if="filterSuggestionLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                        <img v-else class="icon me-2" src="/img/icons/avid-icons/edna.svg" alt="">
                        Refine
                    </button>

                    <button type="submit" class="btn btn-primary" @click.prevent="nextStep()" :disabled="form.busy">
                         <span v-if="file_or_dataset == 'data_set'">Save & </span>Next <div v-if="form.busy" class="spinner-border spinner-border-sm float-left ms-1" role="status"></div><i v-else class="fa fa-chevron-right ms-1"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="row" v-show="step_num==3">
            <!-- AI Working Notice -->
            <div class="col-12 mb-3" v-if="aiMappingInProgress">
                <div class="card ai-working-card is-generating generating-background">
                    <div class="card-body d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                            <img src="/img/images/loading_edna.gif" class="loading-logo me-3" style="width: 32px; height: 32px;">
                            <div>
                                <strong>Avid is analyzing your data...</strong>
                                <p class="mb-0 small text-muted">Edna is working to suggest column mappings. Completed: {{ aiMappingCompleted }}/{{ aiMappingTotal }}</p>
                            </div>
                        </div>
                        <button type="button" class="btn btn-secondary" @click="cancelAIMapping()">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
            <div class="col mb-3">
                <div class="card">
                    <div class="card-body">
                        <h3>Column Mapping</h3>
                        <p class="mb-3">Based upon the "Data Category" selected, there are <a href="https://help.avidai.com/hc/en-us/articles/42928674876819-What-is-in-a-Data-Blend" target="_blank">several mandatory and optional fields to be mapped.</a> <strong>If you have additional columns you'd like to use for filters, be sure to add those columns too.</strong></p>
                        
                        <column-mapping :client="client" :dataset="local_dataset" :dest_columns="dest_columns"
                            ref="column_mapping" v-model="local_dataset.columns" :data_source_id="object_id"
                            :source="file_or_dataset"></column-mapping>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-show="step_num==3">
            <div class="col">
                <div class="alert alert-danger mb-3" v-if="form.error">
                    There was an issue saving the data set. Check the fields above to get more information.
                </div>
                <!-- Save Button -->
                <div class="mb-3">
                    <button type="submit" class="btn btn-primary btn-lg"
                            @click.prevent="save()"
                            :disabled="form.busy">
                        <img v-if="!form.busy" class="icon" src="/img/icons/avid-icons/save.svg" alt="" >
                        <div v-else class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Saving...</span>
                        </div> Save
                    </button>
                </div>
            </div>
        </div>
        
        <!-- Filter Proposal Modal (for files) -->
        <FilterProposalModal
            v-if="file_or_dataset === 'file' && filterProposalModalData"
            :key="filterProposalModalKey || `filter-modal-${object_id}`"
            :client="client"
            :data-set-id="0"
            :file-id="parseInt(object_id)"
            :proposal="filterProposalModalData.proposal"
            :reasoning="filterProposalModalData.reasoning"
            :previous-response-id="filterProposalModalData.previous_response_id"
            :source-type="local_dataset.source_type"
            :source-subtype="local_dataset.source_subtype"
            @accepted="handleFilterProposalAccepted"
            ref="filterProposalModal"
        />
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import { defineComponent } from 'vue';
import { useNotifications } from '../../composables/useNotifications';
import { useAISuggestionPolling, createFileCheckFunction } from '../../composables/useAISuggestionPolling';
import FilterProposalModal from '../components/FilterProposalModal.vue';

export default defineComponent({
    name: 'Mapping',
    components: {
        Swal,
        FilterProposalModal
    },
    props: {
        dataset: {
            type: Object,
            required: true
        },
        files: {
            type: Array,
            default: () => []
        },
        client: {
            type: Object,
            required: true
        },
        source_types: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            local_dataset: null,
            local_files: null,
            dest_columns: [],
            form: {
                error: false,
                busy: false
            },
            errors: {
                name: '',
                category: '',
                pattern: '',
                filter: ''
            },
            filter_type: 1,
            step_num: 1,
            // AI Mapping state
            aiMappingInProgress: false,
            aiMappingTotal: 0,
            aiMappingCompleted: 0,
            aiSuggestions: {},
            aiMappingCompletionNotified: false, // Track if completion notification has been shown
            aiMappingCancelled: false,
            filterSuggestionLoading: false,
            filterProposalModalData: null,
            previousSourceTypeId: null, // Track previous category to detect changes
            filterProposalModalKey: null,
            isProcessingFilterProposal: false,
            echoChannel: null,
        };
    },
    beforeMount() {
        //Make a deep copy of the dataset
        this.local_dataset = JSON.parse(JSON.stringify(this.dataset));
        //Make a null settings into an object
        if(this.local_dataset.settings == null) {
            this.local_dataset.settings = {ignore_unused: true};
        }else if(this.local_dataset.settings.ignore_unused == null)
            this.local_dataset.settings.ignore_unused = true;

        if(this.files == null)
            this.local_files = [];
        else
            this.local_files = this.files;
        
        // Initialize previous category to track changes
        this.previousSourceTypeId = this.local_dataset.source_type_id;

        //Set the fake "source type id" column and the types of columns
        if(this.local_dataset.source_type != null){
            //Foreach to loop through the source_types object
            for (const key in this.source_types) {
                //Need to match on source type and source subtype (which can be null)
                if(this.source_types[key][0].source_type == this.local_dataset.source_type &&
                    (this.local_dataset.source_subtype == null &&
                        this.source_types[key][0].source_subtype == null ||
                        this.local_dataset.source_subtype == this.source_types[key][0].source_subtype)){
                    this.local_dataset.source_type_id = key;
                    this.dest_columns = this.source_types[key];
                    break;
                }
            }
            if(Array.isArray(this.local_dataset.columns) && this.local_dataset.columns.length == 0)
                this.local_dataset.columns = [];
        }

        //If the source_columns isn't set...
        if(this.local_dataset.source_columns == null && this.local_files.length >= 1) {
            this.local_dataset.source_columns = this.local_files[0].columns;
        }

        const params = new URLSearchParams(window.location.search);
        if(params.get('step') != null)
            this.step_num = parseInt(params.get('step'));
    },
    computed: {
        file_or_dataset() {
            var split = window.location.pathname.split("/");
            return split[split.length - 2];
        },
        object_id() {
            var split = window.location.pathname.split("/");
            return split[split.length - 1];
        },
        id_columns() {
            //Loop through the local_dataset.settings.id_columns array (if it isn't null)
            //and return the column names
            if(this.local_dataset.settings.id_columns == null || this.local_dataset.source_columns == null)
                return '';
            else {
                var col = this.local_dataset.source_columns[this.local_dataset.settings.id_columns[0]];
                for(var i = 1; i < this.local_dataset.settings.id_columns.length; i++) {
                    col += ", " + this.local_dataset.source_columns[this.local_dataset.settings.id_columns[i]];
                }
                return col;
            }
        },
        sortedSourceColumns() {
            if (!this.local_dataset.source_columns) {
                return {};
            }
            
            // Convert to array of [key, value] pairs, sort by value (case-insensitive), then convert back to object
            const sortedEntries = Object.entries(this.local_dataset.source_columns)
                .sort(([,a], [,b]) => a.toLowerCase().localeCompare(b.toLowerCase()));
            
            return Object.fromEntries(sortedEntries);
        },
        categoryDescription() {
            if (!this.local_dataset.source_type_id) {
                return null;
            }
            return this.getCategoryDescription(this.local_dataset.source_type_id);
        }
    },
    created() {
        // Initialize notifications composable
        const { showNotification } = useNotifications();
        this.showNotification = showNotification;
        
        // Initialize polling composable for fallback
        const polling = useAISuggestionPolling();
        this.startPolling = polling.startPolling;
        this.stopPolling = polling.stopPolling;
        this.isPolling = polling.isPolling;
    },
    mounted() {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

        for (var i = 0; i < tooltipTriggerList.length; i++) {
          (function(index) {
            tooltipTriggerList[index].addEventListener('click', function() {
              // Hide the tooltip using the index passed to the closure
              tooltipList[index].hide();
            });
            tooltipTriggerList[index].addEventListener('mouseleave', function() {
              // Hide the tooltip using the index passed to the closure
              tooltipList[index].hide();
            });
          })(i);
        }

        // Set up Echo listeners for AI suggestions (only for files)
        if (this.file_or_dataset === 'file') {
            this.setupEchoListeners();
            
            // Listen for notification click events to open filter proposal modal
            window.addEventListener('openFileFilterProposal', this.handleOpenFileFilterProposal);
            
            // Listen for re-enabling suggestion buttons on validation failure
            window.addEventListener('reEnableSuggestion', this.handleReEnableSuggestion);
        }
    },
    beforeUnmount() {
        // Clean up Echo listeners
        if (this.echoChannel) {
            this.echoChannel.stopListening('.column-mapping-suggested');
            this.echoChannel.stopListening('.filter-suggested');
        }
        
        // Clean up notification event listeners
        if (this.file_or_dataset === 'file') {
            window.removeEventListener('openFileFilterProposal', this.handleOpenFileFilterProposal);
            window.removeEventListener('reEnableSuggestion', this.handleReEnableSuggestion);
        }
    },
    watch: {
        local_files(value) {
            this.columnsValid();
        },
    },
    methods: {
        save() {
            this.form.error = false;

            //Validate the query builder
            if(!this.$refs.column_mapping.isValid())
                this.form.error = true;
            else if(!this.columnsValid()){
                this.form.error = true;
                Swal.fire({
                    title: "Error",
                    html: "The columns that you utilized in your column mapping aren't available with all of the matching files. Please delete the files noted in the table or remove the new mappings not present in those files.",
                    icon: "error",
                    customClass: {
                        popup: 'swal-error'
                    },
                }).then((result) => {
                    this.step_num=1;
                });
            }
            else {
                var _self = this;
                this.form.busy = true;

                if(this.local_dataset.id == null) {

                    window.axios.post('/api/data_set/'+this.client.url, this.local_dataset)
                      .then(response => {

                        _self.form.busy = false;
                        
                        // Mark the column mapping component as saved to prevent cleanup of temporary column definitions
                        if (_self.$refs.column_mapping && typeof _self.$refs.column_mapping.markAsSaved === 'function') {
                            _self.$refs.column_mapping.markAsSaved();
                        }
                        
                        Swal.fire({
                            title: "Success!",
                            html: "The data set <strong>"+_self.local_dataset.name +"</strong> was successfully created. The data will be processed shortly and can then be used for analysis and keeping your various systems in sync.",
                            icon: "success",
                            customClass: {
                                popup: 'swal-success'
                            },
                        }).then((result) => {
                            // window.location = "/integrations/"+_self.client.url+"/data_sets"

                            var previous_url = document.referrer;
                            document.location.href = previous_url;
                        });
                      });
                  }
                  //Just update the old filter
                  else {

                    window.axios.put('/api/data_set/'+this.client.url + '/' + this.local_dataset.id, this.local_dataset)
                      .then(response => {

                        _self.form.busy = false;
                        
                        // Mark the column mapping component as saved to prevent cleanup of temporary column definitions
                        if (_self.$refs.column_mapping && typeof _self.$refs.column_mapping.markAsSaved === 'function') {
                            _self.$refs.column_mapping.markAsSaved();
                        }
                        
                        Swal.fire({
                            title: "Success!",
                            html: "The data set <strong>"+_self.local_dataset.name +"</strong> was successfully created. The data will be processed shortly and can then be used for analysis and keeping your various systems in sync.",
                            icon: "success",
                            customClass: {
                                popup: 'swal-success'
                            },
                        }).then((result) => {
                            // window.location = "/integrations/"+_self.client.url+"/data_sets"

                            var previous_url = document.referrer;
                            document.location.href = previous_url;
                        });
                      });
                  }
            }
        },
        nextStep() {
            //Validate the form
            if(this.step_num == 1) {
                if(this.local_dataset.source_type_id == null || this.local_dataset.source_type_id == "") {
                    this.errors.category = "Please select a category for this data set.";
                    this.form.error = true;
                }
                if(this.local_dataset.name == "") {
                    this.errors.name = "Please enter a name for this data set.";
                    this.form.error = true;
                }
                if((this.local_dataset.source != 'Airbyte' && this.local_dataset.source != 'Table') && this.local_dataset.settings.pattern == '') {
                    this.errors.pattern = "Please enter a file pattern to use to identify subsequently uploaded files.";
                    this.form.error = true;
                }
                else if(this.local_dataset.source != 'Airbyte' && this.local_dataset.source != 'Table' && this.local_files.length == 0 ) {
                    this.errors.pattern = "The current pattern doesn't have any matching files. Please update it to match files that have already been uploaded.";
                    this.form.error = true;
                }

                if(!this.form.error){
                    //If something has changed, update the dataset
                    if(this.file_or_dataset == 'data_set' && this.datasetHasChanged()){
                        this.form.busy = true;
                        window.axios.put('/api/data_set/'+this.client.url+ '/' + this.local_dataset.id, this.local_dataset).then(response => {
                            this.local_dataset = response.data.data;
                            this.form.busy = false;
                            this.step_num++;
                            // Trigger AI suggestions for files when moving to step 2
                            this.$nextTick(() => {
                                // Only trigger if category changed (not just on initial load)
                                const categoryChanged = this.previousSourceTypeId !== null && 
                                                       this.previousSourceTypeId !== this.local_dataset.source_type_id;
                                
                                if (this.file_or_dataset === 'file' && this.local_dataset.source_type_id && this.object_id && categoryChanged) {
                                    // Ensure source_type is set (in case setDataSourceType wasn't called)
                                    if (!this.local_dataset.source_type && this.source_types[this.local_dataset.source_type_id]) {
                                        this.local_dataset.source_type = this.source_types[this.local_dataset.source_type_id][0].source_type;
                                        this.local_dataset.source_subtype = this.source_types[this.local_dataset.source_type_id][0].source_subtype;
                                    }
                                    if (this.local_dataset.source_type) {
                                        this.triggerAIMappingSuggestions();
                                    }
                                }
                                // Update previous category after checking
                                this.previousSourceTypeId = this.local_dataset.source_type_id;
                            });
                        });
                    }
                    else {
                        this.step_num++;
                        // Trigger AI suggestions for files when moving to step 2
                        this.$nextTick(() => {
                            // Only trigger if category changed (not just on initial load)
                            const categoryChanged = this.previousSourceTypeId !== null && 
                                                   this.previousSourceTypeId !== this.local_dataset.source_type_id;
                            
                            if (this.file_or_dataset === 'file' && this.local_dataset.source_type_id && this.object_id && categoryChanged) {
                                // Ensure source_type is set (in case setDataSourceType wasn't called)
                                if (!this.local_dataset.source_type && this.source_types[this.local_dataset.source_type_id]) {
                                    this.local_dataset.source_type = this.source_types[this.local_dataset.source_type_id][0].source_type;
                                    this.local_dataset.source_subtype = this.source_types[this.local_dataset.source_type_id][0].source_subtype;
                                }
                                if (this.local_dataset.source_type) {
                                    this.triggerAIMappingSuggestions();
                                }
                            }
                            // Update previous category after checking
                            this.previousSourceTypeId = this.local_dataset.source_type_id;
                        });
                    }
                }
            }
            else if(this.step_num == 2) {
                //Validate the query builder
                if(!this.$refs.filter.isFormValid())
                    this.form.error = true;

                else {
                    this.form.error = false;
                    if(this.file_or_dataset == 'data_set' && this.filterHasChanged()){
                        this.form.busy = true;
                        window.axios.put('/api/data_set/'+this.client.url+ '/' + this.local_dataset.id, this.local_dataset).then(response => {
                            this.local_dataset = response.data.data;
                            this.form.busy = false;
                            this.step_num++;
                        });
                    }

                    else
                        this.step_num++;
                }
            }
        },
        filterHasChanged() {
            return !this.deepEqual( this.local_dataset.filter , this.dataset.filter);
        },
        deepEqual(obj1, obj2){
            if (obj1 === obj2) return true;

            if (typeof obj1 !== 'object' || obj1 === null ||
                typeof obj2 !== 'object' || obj2 === null) {
                return false;
            }

            let keys1 = Object.keys(obj1);
            let keys2 = Object.keys(obj2);

            if (keys1.length !== keys2.length) return false;

            for (let key of keys1) {
                if (!keys2.includes(key) || !this.deepEqual(obj1[key], obj2[key])) {
                    return false;
                }
            }

            return true;
        },
        datasetHasChanged() {
            //If any of the following are different from the dataset prop
            if(this.local_dataset.settings.ignore_unused != this.dataset.settings.ignore_unused)
                return true;
            if(this.local_dataset.settings.pattern != this.dataset.settings.pattern)
                return true;
            if(this.local_dataset.settings.refresh_type != this.dataset.settings.refresh_type)
                return true;
            //ID_Columns is an array, so we need to compare the contents
            if(!this.arraysEqual(this.local_dataset.settings.id_columns, this.dataset.settings.id_columns))
                return true;
        },
        arraysEqual(arr1, arr2) {
            if (arr1.length !== arr2.length) return false;
            arr1 = arr1.slice().sort();
            arr2 = arr2.slice().sort();
            for (let i = 0; i < arr1.length; i++) {
                if (arr1[i] !== arr2[i]) return false;
            }
            return true;
        },
        columnsValid() {
            this.errors.pattern = "";
            this.form.error = false;

            // If it is incremental, all of the local files columns need to match (or be in the most recent one)
            if(this.local_dataset.settings.refresh_type == 'incremental' && this.local_files.length > 1){
                //Check if the URL has "mapping/file" in it
                var recent_file = this.local_files[0];
                var file_id = -1;
                if(window.location.pathname.indexOf("mapping/file") != -1){
                    //Get the fileID from the URL and update the "recent_file" with that file
                    var split = window.location.pathname.split("/");
                    file_id = split[split.length - 1];
                    for(var i = 0; i < this.local_files.length; i++)
                        if(this.local_files[i].id == file_id){
                            recent_file = this.local_files[i];
                            break;
                        }
                }

                //Get an array of the keys of the recent_file.columns object
                var compare_columns = Object.keys(recent_file.columns);
                if(this.local_dataset.settings.ignore_unused){
                    compare_columns = this.getUsedColumns();
                }

                //Look through all of the files
                for(var i = 0; i < this.local_files.length; i++){
                    //Don't worry about the files we're comparing it to
                    if(this.local_files[i].id == recent_file.id)
                        continue;

                    //Loop through each of the columns
                    for (let key in compare_columns) {
                        //If it isn't in the current file's list of columns, throw an error
                        if (!(compare_columns[key] in this.local_files[i].columns)){
                            var file_language = "the most recent";
                            if(file_id >= 0)
                                file_language = "your selected";
                            this.errors.pattern = "The files identified by the given pattern have one or more columns missing when compared to "+file_language+" file. Please update the pattern or delete the files identified in the table.";
                            this.form.error = true;
                            this.local_files[i].status_msg = "MISMATCH";
                            break;
                        }
                        else this.local_files[i].status_msg = "";
                    }
                }
            } else {
                //Reset the status message of the files in case they had previously been flagged
                for(var i = 0; i < this.local_files.length; i++)
                    this.local_files[i].status_msg = "";
            }

            return !this.form.error;

        },
        getUsedColumns(){

            // Get all of the mapped columns from the column definitions relationship
            let columns = this.local_dataset.columns;
            let arr = [];

            // If there are identified ID columns
            let settings = this.local_dataset.settings;
            if (settings.id_columns && settings.refresh_type && settings.refresh_type === 'incremental') {
                // Merge the array into arr
                arr = [...arr, ...settings.id_columns];
            }
            if (columns){
                columns.forEach(c => {
                    // If it isn't a custom definition
                    if (c.source_column !== 'CUSTOM') {
                        // Insert it only if it isn't already in the array (and it has been mapped)
                        if (!arr.includes(c.source_column) && c.source_column) {
                            arr.push(c.source_column);
                        }
                    } else {
                        let logic = c.column_logic;
                        // Check each unit
                        logic.units.forEach(unit => {
                            // Check the value type
                            if (unit.value_type === 'column' && !arr.includes(unit.value)) {
                                arr.push(unit.value);
                            }

                            // Now loop through the logic units
                            unit.logic.logic_units.forEach(u => {
                                // If the right side of the equation is a column mapping
                                if (!u.is_static && !u.show_options && !arr.includes(u.value.value)) {
                                    arr.push(u.value.value);
                                }
                                // Get the left side of the equation
                                if (!arr.includes(u.db_column.value)) {
                                    arr.push(u.db_column.value);
                                }
                            });
                        });

                        // Check the default type
                        if (logic.default_type === 'column' && !arr.includes(logic.default_value)) {
                            arr.push(logic.default_value);
                        }
                    }
                });                    
            }


            return arr;

        },
        setDataSourceType() {
            this.form.error = false;
            this.errors.category = '';
            
            for (const key in this.source_types) {
                if(key == this.local_dataset.source_type_id){
                    this.dest_columns = this.source_types[key];
                    this.local_dataset.source_type = this.source_types[key][0].source_type;
                    this.local_dataset.source_subtype = this.source_types[key][0].source_subtype;
                    break;
                }
            }
            this.local_dataset.columns = null;
            
            // Note: We don't update previousSourceTypeId here - it will be updated in nextStep
            // after checking if it changed, so we can trigger AI suggestions only on category change
        },
        getCategoryDescription(category) {
            const descriptions = {
                'Transactions': 'Use this for financial transaction exports from your CRM system. Each row should represent a single gift or payment.',
                
                'Email Form Submissions': 'Use this for individual form submissions collected through your website or landing page software. Each row should represent one unique submission.',
                
                'Donation Form Submissions': 'Use this for submissions from your donation form platform. Each entry should represent a single donation and include relevant donor and gift details.',
                
                'Constituents': 'Use this for contact exports from your CRM system. Each row should represent one individual. Households will be grouped based on the account ID in the next step.',
                
                'Other': 'Use this for miscellaneous datasets that don’t fit other categories. This is helpful for integrating or enriching records across your CRM, email platform, or other systems.',
                
                'Email Contacts': 'Use this for exports from your email marketing platform. It should include email addresses, contact preferences, and engagement data such as opens and clicks.',
                
                'Activity Feed': 'Use this for any constituent engagement, such as volunteering, event attendance, or program participation. Include an account ID or contact ID for joining with constituent records.',
                
                'Direct Mail Select': 'Use this for lists of donors who received direct mail. Each row should include a unique donor ID and a matching key (e.g., appeal code) to associate with transactions.',
                
                'Email Send': 'Use this for records of marketing emails sent to constituents. Include the email address, send date, and relevant email metadata (e.g., campaign or subject line).',

                'Cost' : 'This is a list of costs associated with a campaign or event. It should include the cost, the appeal code or UTM information to be matched with results.'
            };
            
            return descriptions[category];
        },
        refreshFiles() {
            var self = this;
            self.errors.pattern = "";
            if(this.local_dataset.settings.pattern != "")
                window.axios.post('/api/files/' + this.client.url + '/list_by_pattern',
                    {'pattern': this.local_dataset.settings.pattern }).then(response => {
                    if(response.status == 200) {

                        self.local_files = response.data.files;
                        if(self.local_files.length > 0)
                            self.local_dataset.source_columns = this.local_files[0].columns;
                    }

                  });
            else {
                self.errors.pattern = "You must specify a pattern to identify current and future files with.";
                self.local_files = [];
            }

        },

        removeFile(file) {
            var self  = this;
            Swal.fire({
              title: "Are you sure you want to delete <em>" + file.name + "</em>?",
              text: "This will remove the file from the system and prevent it from being used with future data processes.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, delete",
              customClass: {
                popup: 'swal-warning'
              },
            }).then((result) => {
                  if (result.isConfirmed) {
                    for(var key in self.local_files)
                        if(self.local_files[key].id == file.id) {
                            self.local_files.splice(key, 1);
                            break;
                        }
                    self.columnsValid();
                    window.axios.delete('/api/files/' + self.client.url + '/destroy/' + file.id);
              }
            });

        },

        // ===== AI Suggestion Methods =====
        
        setupEchoListeners() {
            if (!window.Echo) {
                console.warn('Echo not available for AI suggestion listeners');
                return;
            }

            this.echoChannel = window.Echo.private('client.' + this.client.id);
            
            // Listen for column mapping suggestions
            this.echoChannel.listen('.column-mapping-suggested', (data) => {
                // Only process if it's for our file
                if (data.file_id === parseInt(this.object_id)) {
                    this.handleColumnMappingSuggested(data);
                }
            });

            // Listen for filter suggestions
            this.echoChannel.listen('.filter-suggested', (data) => {
                // Only process if it's for our file
                if (data.file_id === parseInt(this.object_id)) {
                    this.handleFilterSuggested(data);
                }
            });
        },

        triggerAIMappingSuggestions() {
            // Count the non-optional columns to set the total
            const nonOptionalColumns = this.dest_columns.filter(col => !col.optional);
            this.aiMappingTotal = nonOptionalColumns.length;
            this.aiMappingCompleted = 0;
            this.aiMappingInProgress = true;
            this.aiMappingCompletionNotified = false; // Reset completion notification flag
            this.aiMappingCancelled = false;
            this.aiSuggestions = {};

            // Set all columns as generating in the ColumnMapping component
            this.$nextTick(() => {
                if (this.$refs.column_mapping && typeof this.$refs.column_mapping.setAllColumnsGenerating === 'function') {
                    this.$refs.column_mapping.setAllColumnsGenerating();
                }
            });

            window.axios.post(`/api/file-mapping/${this.client.url}/suggest-all`, {
                file_id: parseInt(this.object_id),
                source_type: this.local_dataset.source_type,
                source_subtype: this.local_dataset.source_subtype,
            }).then(response => {
                // If no jobs were dispatched, reset state and don't show notifications
                if (response.data.job_count === 0) {
                    this.aiMappingInProgress = false;
                    if (this.$refs.column_mapping && typeof this.$refs.column_mapping.clearAllColumnsGenerating === 'function') {
                        this.$refs.column_mapping.clearAllColumnsGenerating();
                    }
                    return;
                }
                
                this.showNotification({
                    icon: '/img/icons/nav-icons/Edna.svg',
                    text: 'Avid is analyzing your data to suggest column mappings. You\'ll be notified when it\'s ready!',
                    type: 'info'
                });
            }).catch(error => {
                console.error('Error triggering AI suggestions:', error);
                this.aiMappingInProgress = false;
                // Clear generating state on error
                if (this.$refs.column_mapping && typeof this.$refs.column_mapping.clearAllColumnsGenerating === 'function') {
                    this.$refs.column_mapping.clearAllColumnsGenerating();
                }
                this.showNotification({
                    text: error.response?.data?.message || 'Failed to trigger AI suggestions. Please try again.',
                    type: 'error'
                });
            });
        },

        cancelAIMapping() {
            this.aiMappingInProgress = false;
            this.aiMappingCancelled = true;
            if (this.$refs.column_mapping && typeof this.$refs.column_mapping.clearAllColumnsGenerating === 'function') {
                this.$refs.column_mapping.clearAllColumnsGenerating();
            }
        },

        handleColumnMappingSuggested(data) {
            if (this.aiMappingCancelled) {
                return;
            }
            this.aiMappingCompleted++;

            // Store the suggestion
            this.aiSuggestions[data.destination_column] = data.proposal;

            // When AI returns without a suggestion, ensure the field is enabled (clear generating state)
            if (!data.proposal && this.$refs.column_mapping && typeof this.$refs.column_mapping.clearColumnGenerating === 'function') {
                this.$refs.column_mapping.clearColumnGenerating(data.destination_column);
            }

            // Ensure the column exists in the array (add to end if it doesn't exist)
            if (!this.local_dataset.columns) {
                this.local_dataset.columns = [];
            }

            // Check if column already exists
            const columnExists = this.local_dataset.columns.some(
                c => c.destination_column === data.destination_column
            );

            // If column doesn't exist, add it to the end of the array
            if (!columnExists && data.proposal) {
                const destColInfo = this.dest_columns.find(c => c.column === data.destination_column);
                if (destColInfo) {
                    const newColumn = {
                        destination_column: data.destination_column,
                        display_name: destColInfo.name || data.destination_column,
                        data_type: destColInfo.type || 'string',
                        required: destColInfo.optional === false, // Look up the required status
                        source_column: data.auto_accepted && data.proposal ? (data.proposal.source_column || null) : null,
                        column_logic: data.auto_accepted && data.proposal ? (data.proposal.column_logic || null) : null,
                    };
                    this.local_dataset.columns.push(newColumn);
                }
            }

            // If auto-accepted, apply it to the column mapping
            if (data.auto_accepted && data.proposal) {
                this.applyColumnMappingSuggestion(data.destination_column, data.proposal);
            }

            // Check if all mappings are complete (only show notification once)
            if (this.aiMappingCompleted >= this.aiMappingTotal && !this.aiMappingCompletionNotified) {
                this.aiMappingInProgress = false;
                this.aiMappingCompletionNotified = true; // Mark as notified to prevent duplicate notifications
                
                // Clear generating state for all columns
                if (this.$refs.column_mapping && typeof this.$refs.column_mapping.clearAllColumnsGenerating === 'function') {
                    this.$refs.column_mapping.clearAllColumnsGenerating();
                }
                
                if(this.step_num == 3) {
                    this.showNotification({
                        icon: '/img/icons/nav-icons/Edna.svg',
                        text: 'Avid has finished analyzing your data. Review the suggested mappings below.',
                        type: 'success'
                    });
                }
                else {
                    this.showNotification({
                        icon: '/img/icons/nav-icons/Edna.svg',
                        text: 'Avid has finished analyzing your data. Review the suggested mappings on the 3rd step.',
                        type: 'success'
                    });
                }
            }
        },

        applyColumnMappingSuggestion(destinationColumn, proposal) {
            // Find the column in the local_dataset.columns and update it
            if (!this.local_dataset.columns) {
                this.local_dataset.columns = [];
            }

            // Find existing column or create new one
            let columnIndex = this.local_dataset.columns.findIndex(
                c => c.destination_column === destinationColumn
            );

            if (columnIndex === -1) {
                // Create new column mapping
                const destColInfo = this.dest_columns.find(c => c.column === destinationColumn);
                if (destColInfo) {
                    const newColumn = {
                        destination_column: destinationColumn,
                        display_name: destColInfo.name || destinationColumn,
                        data_type: destColInfo.type || 'string',
                        source_column: proposal.source_column || null,
                        column_logic: proposal.column_logic || null,
                    };
                    this.local_dataset.columns.push(newColumn);
                }
            } else {
                // Update existing column
                this.local_dataset.columns[columnIndex].source_column = proposal.source_column || null;
                this.local_dataset.columns[columnIndex].column_logic = proposal.column_logic || null;
            }

            // Force update on the column mapping component
            if (this.$refs.column_mapping) {
                this.$refs.column_mapping.$forceUpdate();
            }
        },

        requestFilterSuggestion() {
            // Prompt for context
            Swal.fire({
                title: 'Refine Filter',
                html: `
                    <p class="mb-2">What information do you want to include or exclude from this data set?</p>
                    <textarea id="filter-context" class="form-control" placeholder="E.g., Exclude non-gift transaction types; Only include active constituents; etc." style="width: 100%; min-height: 100px;"></textarea>
                `,
                showCancelButton: true,
                confirmButtonText: 'Submit',
                cancelButtonText: 'Cancel',
                didOpen: () => {
                    const textarea = Swal.getPopup()?.querySelector('#filter-context');
                    if (textarea) {
                        textarea.focus();
                    }
                },
                preConfirm: () => {
                    const context = document.getElementById('filter-context').value;
                    return context || null;
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    const userContext = result.value || '';
                    this.filterSuggestionLoading = true;

                    window.axios.post(`/api/file-mapping/${this.client.url}/suggest-filter`, {
                        file_id: parseInt(this.object_id),
                        source_type: this.local_dataset.source_type,
                        source_subtype: this.local_dataset.source_subtype,
                        user_context: userContext,
                        current_filter: this.local_dataset.filter, // Send current filter as context
                    }).then(() => {
                        this.showNotification({
                            icon: '/img/icons/nav-icons/Edna.svg',
                            text: 'AI is analyzing your data to suggest a filter. You\'ll be notified when it\'s ready!',
                            type: 'info'
                        });
                        
                        // Start polling as fallback for missed Echo events
                        const requestKey = `filter-file-${this.object_id}`;
                        this.startPolling({
                            requestKey,
                            checkFn: createFileCheckFunction({
                                clientUrl: this.client.url,
                                fileId: parseInt(this.object_id),
                                type: 'filter'
                            }),
                            onSuccess: (data) => {
                                this.filterSuggestionLoading = false;
                                if (data && data.proposal) {
                                    // Show notification that polling detected the update
                                    this.showNotification({
                                        icon: '/img/icons/nav-icons/Edna.svg',
                                        text: 'AI has suggested a filter for your data. Click to review.',
                                        type: 'success',
                                        action: {
                                            type: 'openFileFilterProposal',
                                            file_id: parseInt(this.object_id),
                                            proposal: data.proposal,
                                            reasoning: data.reasoning,
                                            previous_response_id: data.response_id
                                        }
                                    });
                                }
                            },
                            onTimeout: () => {
                                this.filterSuggestionLoading = false;
                            },
                            onNoResult: () => {
                                this.filterSuggestionLoading = false;
                                this.showNotification({
                                    icon: '/img/icons/avid-icons/danger.svg',
                                    text: 'The AI suggestion completed but no changes were detected. Please try again.',
                                    type: 'error'
                                });
                            }
                        });
                    }).catch(error => {
                        console.error('Error requesting filter suggestion:', error);
                        this.filterSuggestionLoading = false;
                        this.showNotification({
                            text: error.response?.data?.message || 'Failed to request filter suggestion. Please try again.',
                            type: 'error'
                        });
                    });
                }
            });
        },

        handleFilterSuggested(data) {
            this.filterSuggestionLoading = false;
            
            // Stop polling since we received the Echo event
            const requestKey = `filter-file-${this.object_id}`;
            if (this.stopPolling) {
                this.stopPolling(requestKey);
            }
            
            if (data.auto_accepted && data.proposal) {
                // Apply the filter directly
                this.local_dataset.filter = data.proposal;
                if (this.$refs.filter) {
                    this.$refs.filter.$forceUpdate();
                }
                this.showNotification({
                    icon: '/img/icons/nav-icons/Edna.svg',
                    text: 'AI has suggested a filter for your data.',
                    type: 'success'
                });
            }
            // Note: When not auto-accepted, the notification is shown by the backend/Pusher
            // and handled by useNotifications.js. The user will click the notification
            // to open the modal via handleOpenFileFilterProposal.
            // We do NOT auto-show the modal here.
        },

        handleFilterProposalAccepted(data) {
            // Clear processing flag when modal is closed/accepted
            this.isProcessingFilterProposal = false;
            
            // Stop polling since proposal was accepted
            const requestKey = `filter-file-${this.object_id}`;
            if (this.stopPolling) {
                this.stopPolling(requestKey);
            }
            
            // Apply the filter
            this.local_dataset.filter = data.filter;
            if (this.$refs.filter) {
                this.$refs.filter.$forceUpdate();
            }
            
            this.showNotification({
                icon: '/img/icons/nav-icons/Edna.svg',
                text: 'Filter suggestion accepted and applied.',
                type: 'success'
            });
        },


        handleOpenFileFilterProposal(event) {
            const actionData = event.detail;
            
            // Only handle if it's for our file
            if (!actionData || actionData.file_id !== parseInt(this.object_id)) {
                return;
            }
            
            // Stop polling since we received the event
            const requestKey = `filter-file-${this.object_id}`;
            if (this.stopPolling) {
                this.stopPolling(requestKey);
            }

            // Prevent processing if already processing
            if (this.isProcessingFilterProposal) {
                console.log('Filter proposal already being processed, ignoring duplicate event');
                return;
            }

            // Mark as processing
            this.isProcessingFilterProposal = true;

            // Navigate to step 2 if not already there
            if (this.step_num !== 2) {
                this.step_num = 2;
            }

            // Prefer proposal payload from the notification (more reliable than file metadata).
            if (actionData.proposal) {
                const newData = {
                    proposal: actionData.proposal,
                    reasoning: actionData.reasoning || null,
                    previous_response_id: actionData.previous_response_id || null,
                };
                
                // Always update the key to force remount with new data
                this.filterProposalModalData = newData;
                this.filterProposalModalKey = `filter-modal-${this.object_id}-${Date.now()}`;

                this.$nextTick(() => {
                    // Wait for the component to remount with new key
                    this.$nextTick(() => {
                        if (this.$refs.filterProposalModal) {
                            // Always show the modal with new data, even if it was already open
                            this.$refs.filterProposalModal.show();
                            const modalElement = this.$refs.filterProposalModal.$el;
                            modalElement.addEventListener('hidden.bs.modal', () => {
                                this.isProcessingFilterProposal = false;
                            }, { once: true });
                        } else {
                            this.isProcessingFilterProposal = false;
                        }
                    });
                });

                return;
            }

            // Fallback: Load the filter proposal from file metadata
            this.$nextTick(() => {
                // Fetch the file to get the latest metadata
                window.axios.get(`/api/file-mapping/${this.client.url}/${this.object_id}/status`)
                    .then(response => {
                        const filterSuggestion = response.data.ai_filter_suggestion;
                        if (filterSuggestion && filterSuggestion.proposal) {
                            // Only update key if data actually changed to avoid unnecessary remounts
                            const newData = {
                                proposal: filterSuggestion.proposal,
                                reasoning: filterSuggestion.reasoning,
                                previous_response_id: filterSuggestion.response_id || null,
                            };
                            
                            // Check if data actually changed
                            const dataChanged = !this.filterProposalModalData || 
                                JSON.stringify(this.filterProposalModalData.proposal) !== JSON.stringify(newData.proposal) ||
                                this.filterProposalModalData.reasoning !== newData.reasoning ||
                                this.filterProposalModalData.previous_response_id !== newData.previous_response_id;
                            
                            if (dataChanged) {
                                this.filterProposalModalData = newData;
                                this.filterProposalModalKey = `filter-modal-${this.object_id}-${Date.now()}`;
                            }
                            
                            this.$nextTick(() => {
                                if (this.$refs.filterProposalModal) {
                                    // Check if modal is already shown before trying to show it
                                    const modalElement = this.$refs.filterProposalModal.$el;
                                    const modalInstance = window.bootstrap?.Modal?.getInstance(modalElement);
                                    if (modalElement && (!modalInstance || !modalElement.classList.contains('show'))) {
                                        this.$refs.filterProposalModal.show();
                                        
                                        // Listen for modal hidden event to clear processing flag
                                        modalElement.addEventListener('hidden.bs.modal', () => {
                                            this.isProcessingFilterProposal = false;
                                        }, { once: true });
                                    } else {
                                        // Modal already shown, clear flag
                                        this.isProcessingFilterProposal = false;
                                    }
                                } else {
                                    // Modal ref not available, clear flag
                                    this.isProcessingFilterProposal = false;
                                }
                            });
                        } else {
                            this.isProcessingFilterProposal = false;
                            this.showNotification({
                                text: 'Filter suggestion not found. It may have already been processed.',
                                type: 'info'
                            });
                        }
                    })
                    .catch(error => {
                        console.error('Error loading filter proposal:', error);
                        this.isProcessingFilterProposal = false;
                        this.showNotification({
                            text: 'Failed to load filter suggestion. Please try again.',
                            type: 'error'
                        });
                    });
            });
        },
        handleReEnableSuggestion(event) {
            const actionData = event.detail;
            if (!actionData || actionData.file_id !== parseInt(this.object_id)) {
                return;
            }
            
            // Handle filter suggestion re-enable
            if (!actionData.destination_column) {
                this.filterSuggestionLoading = false;
            } else if (this.$refs.column_mapping) {
                // Handle column mapping suggestion re-enable (e.g. status failed) – remove lock on that column
                if (typeof this.$refs.column_mapping.clearColumnGenerating === 'function') {
                    this.$refs.column_mapping.clearColumnGenerating(actionData.destination_column);
                }
                const columnIndex = this.local_dataset.columns.findIndex(
                    c => c.destination_column === actionData.destination_column
                );
                if (columnIndex !== -1 && this.$refs.column_mapping.ednaButtonDisabled) {
                    this.$refs.column_mapping.ednaButtonDisabled[columnIndex] = false;
                }
            }
        },

    }
});
</script>
